import React, {Component} from 'react'
import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label
} from "reactstrap";
import Select from "../../local_node_modules/react-select";
import {request} from "../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";
import DefaultModal from "../invoice/DefaultModal";
import moment from "moment";
import Datetime from "react-datetime";
import {isValidVersion} from "../../common/componentValidation";
import {validateField} from "../../common/validation";
import {EntegratorIdentifiers} from "../../helper/enums";

class VersionModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            version: undefined,
            versionInfo: {},
            versionDetails: [],
            btnDisabled: false,
            selectedList: [],
            error: {},
            subOptions: []
        };
        this.save = this.save.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.addDetailLine = this.addDetailLine.bind(this);
        this.removeDetailLine = this.removeDetailLine.bind(this);
        this.onEntegratorChange = this.onEntegratorChange.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    componentDidMount() {

        let {mode, recordId} = this.props;
        if ((mode === "update" || mode === "view") && recordId) {
            let self = this;
            let params = {
                url: "/version/fetchVersionByRecordId",
                method: 'post',
                data: recordId
            };

            request(params).then(function (response) {
                self.setState({versionDetails: response.data.versionDetails, versionInfo: response.data});

                let temp = [];
                const myArray = Object.entries(EntegratorIdentifiers).map(entry => {
                    return {value:entry[1], label:entry[0]};
                });

                myArray.map((item) => {
                    if (response.data.showOn.includes(item.value)) {
                        temp.push(item);
                    }
                });
                self.setState({selectedList: temp})
                console.log("AAA", response.data)
            }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            let versionInfo = this.state.versionInfo;
            versionInfo.releaseDate = moment(new Date()).format("YYYY-MM-DD")
            this.setState({versionInfo});
        }


    }

    editHandleInputChange = (event) => {
        let self = this;
        let versionInfo = deepCopyObject(this.state.versionInfo);
        const {name, value} = event.target;
        versionInfo[name] = value;
        self.setState({versionInfo});
    }

    changeDate = (momentObj, fieldName) => {
        let value;
        if (!(typeof momentObj === "string")) {
            value = momentObj.format("YYYY-MM-DD");
        } else {
            if (momentObj.length === 0) {
                value = undefined;
            }
            value = momentObj;
        }

        let versionInfo = this.state.versionInfo;
        versionInfo.releaseDate = value;

        this.setState({versionInfo});
    }

    editHandleDetailInputChange = (event, index) => {

        let self = this;
        let versionDetails = deepCopyObject(this.state.versionDetails);
        let versionInfo = deepCopyObject(this.state.versionInfo);

        const {name, value} = event.target;
        versionDetails[index][name] = value;

        versionInfo.versionDetails = versionDetails;
        self.setState({versionInfo, versionDetails});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary;
        if (id === "gtip" && e.target.value > 0) {
            boundary = this.props.isGtipRequired === true ? "12,12" : "0,12";
            rule = "gtip";
        } else {
            boundary = e.target.dataset.vlength;
        }
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    save(e) {
        e.preventDefault();

        let data = deepCopyObject(this.state.versionInfo);
        let result = isValidVersion(data);
        let error = result.error;
        let valid = result.valid;

        if (valid) {
            let self = this;
            let params = {
                url: "/version/addVersion",
                method: 'post',
                data: self.state.versionInfo
            };

            this.setState({btnDisabled: true});
            request(params).then(function (response) {
                self.setState({btnDisabled: false});
                Alert.success("Versiyon kayıt işlemi başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
                self.props.listener(false, true);
            }).catch(function (error) {
                self.setState({btnDisabled: false});
                showAxiosError(error);
            });
        } else {
            this.setState({error});
        }
    }

    onCancel() {
        this.props.listener(false, false);
    }

    addDetailLine() {
        let versionDetails = deepCopyObject(this.state.versionDetails);

        let versionDetail = {
            title: null,
            description: null,
            file: null,
            fileType: null,
            showOn: null
        };
        versionDetails.push(versionDetail);

        this.setState({versionDetails});
    }

    removeDetailLine(index) {
        let versionDetails = deepCopyObject(this.state.versionDetails);
        versionDetails.splice(index, 1);

        let versionInfo = deepCopyObject(this.state.versionInfo);
        versionInfo.versionDetails = versionDetails;

        this.props.listener(versionDetails);
        this.setState({versionDetails, versionInfo});
    }

    onEntegratorChange(data) {
        let versionInfo = deepCopyObject(this.state.versionInfo);
        versionInfo.showOn = data.map(item => item.value).join(",");

        this.setState({versionInfo, selectedList: data});
    }

    onEntegratorChangeDetail(data, index) {
        let versionDetails = deepCopyObject(this.state.versionDetails);
        versionDetails[index].showOn = data.map(item => item.value).join(",");

        let versionInfo = deepCopyObject(this.state.versionInfo);
        versionInfo.versionDetails = versionDetails;

        this.setState({versionDetails, versionInfo});
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    deleteFile = (index) => {
        let versionInfo = deepCopyObject(this.state.versionInfo);
        let versionDetails = deepCopyObject(this.state.versionDetails);
        versionInfo.versionDetails[index].file = undefined;
        versionDetails[index].file = undefined;
        versionInfo.versionDetails[index].fileType = undefined;
        versionDetails[index].fileType = undefined;

        this.setState({
            versionInfo, versionDetails
        })
    }

    handleFileInputChange = (index, e) => {

        let uploadFile = e.target.files[0];

        let sizeString = (uploadFile.size / 1024).toFixed(2);
        let sizeNumber = Number(sizeString);

        let extensions = uploadFile.type.split("/");
        let fileExtension = extensions[1];


        if (sizeNumber <= 5120 && (fileExtension === "jpeg" || fileExtension === "jpg" || fileExtension === "png" || fileExtension === "gif")) {

            let versionDetails = deepCopyObject(this.state.versionDetails);
            versionDetails[index].fileType = fileExtension;

            this.getBase64(uploadFile)
                .then(result => {
                    versionDetails[index].file = result;

                    let versionInfo = deepCopyObject(this.state.versionInfo);
                    versionInfo.versionDetails = versionDetails;

                    this.setState({versionDetails, versionInfo});
                })
                .catch(err => {
                    console.log(err);
                });

        } else if (sizeNumber > 5120) {
            Alert.error("Daha düşük boyutlu bir dosya seçiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        } else {
            Alert.error("Uygun formatta bir dosya seçiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
    };

    getBase64 = file => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    entegratorList = () => {
        return Object.entries(EntegratorIdentifiers).map(entry => {
             return {value:entry[1], label:entry[0]};
        });
    }

    render() {
        let {versionInfo} = this.state;

        return (
            <DefaultModal
                isOpen={this.props.modal}
                disabled={this.state.btnDisabled}
                title={`Versiyon ${this.props.mode === "create" ? "Oluştur" : this.props.mode === "view" ? "Görüntüle" : "Düzenle"} `}
                size="lg"
                modalBodyStyle={{padding: "0"}}
                confirmBtnText={this.props.mode === "view" ? null : "Kaydet"}
                cancelBtnText={this.props.mode === "view" ? "Kapat" : "İptal"}
                onConfirm={(e) => this.save(e)}
                onCancel={this.onCancel}>
                <Form className="px-4">
                    <FormGroup row>
                        <Label sm={4}>Versiyon No</Label>
                        <Col sm={8} className={this.validateClass("versionNo")}>
                            <Input type="text" name="versionNo" id="versionNo" value={versionInfo.versionNo}
                                   disabled={this.props.mode === "view"}
                                   onChange={(event) => this.editHandleInputChange(event)}
                                   onBlur={(e) => this.validateField(e)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Başlık</Label>
                        <Col sm={8} className={this.validateClass("title")}>
                            <Input type="text" name="title" id="title" value={versionInfo.title}
                                   disabled={this.props.mode === "view"}
                                   onChange={(event) => this.editHandleInputChange(event)}
                                   onBlur={(e) => this.validateField(e)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Yayınlanma Tarihi</Label>
                        <Col sm={8}>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      inputProps={this.props.mode === "view" ? {id: 'issueDate', disabled: true} : {id: 'issueDate'}}
                                      closeOnSelect={true}
                                      value={moment(versionInfo.releaseDate)}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat={false}
                                      onChange={(e) => this.changeDate(e, "date")}
                                      isValidDate={function (current) {
                                          return current.isBefore(Datetime.moment());
                                      }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Açıklama</Label>
                        <Col sm={8}>
								<textarea style={{width: "100%"}} name="description"
                                          value={versionInfo.description}
                                          disabled={this.props.mode === "view"}
                                          rows="5"
                                          onChange={(event) => this.editHandleInputChange(event)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Gösterilecekler</Label>
                        <Col sm={8} className={this.validateClass("showOn")}>
                            <Select
                                className="select-control"
                                name="showOn"
                                id="showOn"
                                disabled={this.props.mode === "view"}
                                multi={true}
                                ref="tAlias"
                                placeholder="Entegrator Seçiniz..."
                                value={versionInfo.showOn}
                                onChange={(e, value) => e && this.onEntegratorChange(e, value)}
                                options={this.entegratorList()}
                                onBlur={(e) => this.validateField(e)}
                            />
                        </Col>
                    </FormGroup>
                    <div className="row">
                        <div className="container">
                            <button type="button"
                                    className="TekBtn ekle hizala pull-right btn-default btn-md my-3"
                                    style={this.props.mode === "view" ? {display: 'none'} : null}
                                    onClick={(e) => this.addDetailLine(false)}>Detay Ekle
                            </button>
                        </div>
                    </div>
                    <hr/>

                    {this.state.versionDetails.map((detail, index) => {
                        return (
                            <div className="py-2" key={index}>
                                <div className="mb-2">
                                    <span className="h6">{`Versiyon Detayı - ${index + 1}`}</span>
                                    <button type="button"
                                            style={this.props.mode === "view" ? {display: 'none'} : {margin: "0", background: '#FFCCCC'}}
                                            className="Btn temizle float-right"
                                            onClick={(e) => this.removeDetailLine(index)}>
                                    </button>
                                </div>

                                <FormGroup row>
                                    <Label sm={4}>Başlık</Label>
                                    <Col>
                                        <Input type="text" name="title" value={detail.title}
                                               disabled={this.props.mode === "view"}
                                               onChange={(event) => this.editHandleDetailInputChange(event, index)}/>
                                    </Col>
                                </FormGroup>

                                <FormGroup row>
                                    <Label sm={4}>Açıklama</Label>
                                    <Col>
                                        <textarea style={{width: "100%"}} name="description"
                                                  disabled={this.props.mode === "view"}
                                                  value={detail.description} rows="5"
                                                  onChange={(event) => this.editHandleDetailInputChange(event, index)}/>
                                    </Col>
                                </FormGroup>

                                <FormGroup row>
                                    <Label sm={4}>Gösterilecekler</Label>
                                    <Col sm={8}>
                                        <Select
                                            className="select-control"
                                            disabled={this.props.mode === "view"}
                                            name="showOn"
                                            multi={true}
                                            ref="tAlias"
                                            placeholder="Entegrator Seçiniz..."
                                            value={detail.showOn}
                                            onChange={(e) => e && this.onEntegratorChangeDetail(e, index)}
                                            options={this.state.selectedList}
                                        />
                                    </Col>
                                </FormGroup>

                                <FormGroup row>
                                    <Label sm={4}>Resim</Label>

                                    {detail.file ?
                                        <Col sm={8} className="d-flex align-items-center">
                                            <div className="rounded pt-1">
                                                <img className="rounded d-block w-50" src={detail.file}/>
                                            </div>
                                            <Button onClick={() => this.deleteFile(index)}
                                                    style={this.props.mode === "view" ? {display: 'none'} : null}
                                                    className="text-white bg-danger rounded-circle" size="sm">
                                                Kaldır
                                            </Button>
                                        </Col>
                                        :
                                        <Col sm={8} className="row">
                                            <div className="col-11"/>
                                            <div className="col-1">
                                                <Button className="text-white bg-warning mx-auto" size="sm" style={this.props.mode === "view"  ? {display: 'none'} : null }>
                                                    <i className="fas fa-plus" style={{fontSize: "small"}}/>
                                                    <Input className="ml-3" type="file" name="file" accept=".jpeg, .jpg, .png, .gif"
                                                           onChange={(e) => this.handleFileInputChange(index, e)}/>
                                                </Button>
                                            </div>
                                        </Col>
                                    }
                                </FormGroup>
                                <hr/>
                            </div>
                        );
                    })
                    }
                </Form>
            </DefaultModal>
        )
    }
}

export default VersionModal;